import type { FC } from 'react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import type { ResponseRateData } from 'src/types/dashboard';

import { styles } from './WidgetFooter.styles';

interface WidgetFooterProps {
  responseRateData?: ResponseRateData;
}

const WidgetFooter: FC<WidgetFooterProps> = ({ responseRateData }) => {
  const { t } = useTranslation('dashboard');
  const { responseRate, invited, respondents } = useMemo(
    () => responseRateData || {},
    [responseRateData],
  );

  return (
    <Stack direction="row" sx={styles.stats}>
      <Stack direction="column" spacing={1}>
        <Typography variant="h6">{t('Labels.ResponseRate')}</Typography>
        <Typography variant="h6">
          {typeof responseRate === 'number' && Number.isFinite(responseRate)
            ? `${Math.round(responseRate)}%`
            : '-'}
        </Typography>
      </Stack>
      <Stack direction="column" spacing={1}>
        <Typography variant="h6">{t('Labels.Invited')}</Typography>
        <Typography variant="h6">{invited ?? '-'}</Typography>
      </Stack>
      <Stack direction="column" spacing={1}>
        <Typography variant="h6">{t('Labels.Respondents')}</Typography>
        <Typography variant="h6">{respondents ?? '-'}</Typography>
      </Stack>
    </Stack>
  );
};

export default WidgetFooter;
